/**
 * @pageName OnlineOrders
 * @slotType dashboard menu plugin
 */
export type OrderCardMoreActionsMenuParams = {
  // Order ID.
  orderId: string;
};
